var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare52A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 58",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M41.758 20.151a2.5 2.5 0 0 1-3.062-1.768L35.85 7.758a2.5 2.5 0 0 1 1.768-3.062l9.66-2.588a2.5 2.5 0 0 1 3.061 1.768L53.185 14.5a2.5 2.5 0 0 1-1.768 3.062l-9.659 2.588Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M43.208 19.762a1 1 0 0 1 .707-1.224l7.245-1.941a1.5 1.5 0 0 0 1.06-1.838L49.373 4.134a1.5 1.5 0 0 0-1.837-1.06l-7.244 1.94a1 1 0 1 1-.518-1.931l7.244-1.941a3.5 3.5 0 0 1 4.287 2.475l2.847 10.625a3.5 3.5 0 0 1-2.475 4.286l-7.244 1.942a1 1 0 0 1-1.225-.707Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M37.617 53.304a2.5 2.5 0 0 1-1.768-3.062l2.847-10.625a2.5 2.5 0 0 1 3.062-1.768l9.66 2.588a2.5 2.5 0 0 1 1.767 3.062l-2.847 10.625a2.5 2.5 0 0 1-3.062 1.768l-9.659-2.588Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M39.067 53.692a1 1 0 0 1 1.225-.707l7.244 1.941a1.5 1.5 0 0 0 1.837-1.06L52.22 43.24a1.5 1.5 0 0 0-1.06-1.837l-7.245-1.942a1 1 0 1 1 .518-1.931l7.244 1.94a3.5 3.5 0 0 1 2.475 4.287l-2.847 10.625a3.5 3.5 0 0 1-4.286 2.475l-7.245-1.94a1 1 0 0 1-.707-1.226Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13.5 38.333a2.5 2.5 0 0 1 2.5 2.5V52.5a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 1 52.5V38.333h12.5ZM13.5 20.666a2.5 2.5 0 0 1 2.5 2.5v11.667a2.5 2.5 0 0 1-2.5 2.5H1V20.667h12.5ZM13.5 3A2.5 2.5 0 0 1 16 5.5v11.667a2.5 2.5 0 0 1-2.5 2.5H1V5.5A2.5 2.5 0 0 1 3.5 3h10Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M12 55a1 1 0 0 1-1 1H3.5A3.5 3.5 0 0 1 0 52.5v-47A3.5 3.5 0 0 1 3.5 2H11a1 1 0 1 1 0 2H3.5A1.5 1.5 0 0 0 2 5.5v47A1.5 1.5 0 0 0 3.5 54H11a1 1 0 0 1 1 1Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M34 44.542c0 .805-.653 1.458-1.458 1.458H21.458A1.458 1.458 0 0 1 20 44.542V33.458c0-.805.653-1.458 1.458-1.458h11.084c.805 0 1.458.653 1.458 1.458v11.084ZM34 24.542c0 .805-.653 1.458-1.458 1.458H21.458A1.458 1.458 0 0 1 20 24.542V13.458c0-.805.653-1.458 1.458-1.458h11.084c.805 0 1.458.653 1.458 1.458v11.084Z"
})));
SvgSquare52A.viewBox = '0 0 56 58';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare52A);
export default ForwardRef;